import React, { useEffect, useState } from 'react';

import Button from '@atlaskit/button';
import Toggle from '@atlaskit/toggle';

import { SentryUtils } from '@qality/premium';

import {
  JiraAdminSettingsSectionLabelsSubtitle,
  JiraAdminSettingsSectionTitle,
  JiraAdminSettingsSectionToggle,
} from '../JiraAdminSettings.styled';
import {
  SentrySettingsContainer,
  SentrySettingsDescriptionStyled,
} from './SentrySettings.styled';

const SECURITY_AND_PRIVACY_POLICY_URL =
  'https://soldevelo.com/products/soldevelo-apps-for-atlassian-products-data-security-privacy-statement/';

export default function SentrySettings(): JSX.Element {
  const [isSentryRecordingEnabled, setIsSentryRecordingEnabled] =
    useState(false);

  const [isDisabled, setIsDisabled] = useState(false);

  const toggleSentryRecordingSetting = async () => {
    setIsDisabled(true);
    await SentryUtils.setSentryAgreementProperty(!isSentryRecordingEnabled);
    setIsSentryRecordingEnabled((prev) => !prev);
    setIsDisabled(false);
  };

  const initializeSentryRecordingSetting = async () => {
    const isSentryRecordingAllowed: boolean =
      await SentryUtils.isSentryRecordingAllowed();
    setIsSentryRecordingEnabled(isSentryRecordingAllowed);
  };

  useEffect(() => {
    initializeSentryRecordingSetting();
  }, []);

  return (
    <SentrySettingsContainer>
      <JiraAdminSettingsSectionTitle>
        Session recordings
      </JiraAdminSettingsSectionTitle>

      <SentrySettingsDescriptionStyled>
        It helps us improve your experience by tracking how the app performs. If
        you allow us to record sessions, we can better understand how to make
        the app even better for you. Rest assured, all private user data,
        including text and images, are anonymized and masked. To learn more,
        please read our{' '}
        <Button
          spacing='none'
          appearance='link'
          onClick={() => window.open(SECURITY_AND_PRIVACY_POLICY_URL, '_blank')}
        >
          privacy policy.
        </Button>
      </SentrySettingsDescriptionStyled>
      <JiraAdminSettingsSectionToggle>
        <Toggle
          onChange={toggleSentryRecordingSetting}
          isChecked={isSentryRecordingEnabled}
          size='large'
          isDisabled={isDisabled}
        />
      </JiraAdminSettingsSectionToggle>

      <h3>Enable session recordings for this Jira instance</h3>
      <JiraAdminSettingsSectionLabelsSubtitle>
        When enabled, sessions of users on this Jira instance can be recorded.
      </JiraAdminSettingsSectionLabelsSubtitle>
    </SentrySettingsContainer>
  );
}
